module.exports = __webpack_public_path__ + "static/media/magento.6353e2be.svg";